import { useTranslation } from "react-i18next";
import { ZINDEX_LEVELS } from "../Helpers/Enums";

const SessionTimeoutModal = ({ onClose = () => {}, title, message }) => {
  const { t: translation } = useTranslation();

  return (
    <div
      className="modal fade show"
      id="myModal"
      role="dialog"
      style={{ display: "block", zIndex: ZINDEX_LEVELS.LEVEL_1 }}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-body">
            <div className="d-flex flex-column align-items-center gap-4">
              <img
                src="assets/images/session-timeout.png"
                alt={title}
                style={{ width: "150px" }}
              />

              <div className="text-center">
                <h3
                  className="fw-bold"
                  style={{ fontSize: "28px", color: "var(--custom-primary)" }}
                >
                  {title}
                </h3>

                <p
                  id="error"
                  style={{
                    color: "var(--custom-primary)",
                    fontSize: "20px",
                    fontWeight: "400",
                  }}
                >
                  {message}
                </p>
              </div>

              <button
                type="button"
                className="btn btn-primary fs-3 px-5"
                style={{ borderRadius: "0.6rem" }}
                onClick={onClose}
              >
                {translation("labels.login")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutModal;
